export default __webpack_public_path__ + "static/media/shop.6cf56c4c.png";